import { JobStatusService } from './job-status.service';

export const services: any[] = [JobStatusService];

export * from './job-status.service';
